const TextareaField = ({
  label,
  value,
  onChange,
  id,
  style,
  className,
  classNameBox,
}) => {
  return (
    <div className={`textareaGroup ${classNameBox}`}>
      <textarea
        id={id}
        value={value}
        onChange={onChange}
        style={style}
        required
        autoComplete="off"
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
};
export default TextareaField;
